export const IGUMPendingState = {
    PENDING_UNMUTE: 1,
    NONE: 2
}
